import { regionContext } from "@components/region/RegionProvider";
import { useContext } from "react";

export const useRegion = () => useContext(regionContext);
